import { motion } from "framer-motion";
import { FadeIn, StaggeredGrid } from "@/components/animated";
import { premiumFeatures } from "@/data/homePageData";
import { Video, Code, Users, Zap, CheckCircle } from "lucide-react";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  Video: Video,
  Code: Code,
  Users: Users,
  Zap: Zap,
};

export function FeaturesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container">
        <FadeIn>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-sm font-medium rounded-full mb-4">
              Por qué elegirnos
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-secondary-900 mb-4">
              Aprende con las mejores herramientas
            </h2>
            <p className="text-secondary-600 max-w-2xl mx-auto">
              Cada detalle está diseñado para maximizar tu aprendizaje y
              acelerar tu crecimiento profesional
            </p>
          </div>
        </FadeIn>

        <StaggeredGrid
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"
          staggerDelay={0.1}
        >
          {premiumFeatures.map((feature) => {
            const Icon = iconMap[feature.icon] || CheckCircle;
            return (
              <motion.div
                key={feature.id}
                whileHover={{ y: -8, transition: { duration: 0.2 } }}
                className="group"
              >
                <div className="bg-secondary-50 rounded-2xl p-6 h-full transition-all duration-300 group-hover:bg-primary-50 group-hover:shadow-lg">
                  {/* Icon */}
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white shadow-sm text-primary-600 mb-5 group-hover:bg-primary-600 group-hover:text-white transition-colors duration-300">
                    <Icon className="h-7 w-7" />
                  </div>

                  {/* Highlight tag */}
                  <div className="inline-block px-3 py-1 bg-gold-100 text-gold-700 text-xs font-semibold rounded-full mb-3">
                    {feature.highlight}
                  </div>

                  {/* Title */}
                  <h3 className="text-lg font-semibold text-secondary-900 mb-2">
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p className="text-secondary-600 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </StaggeredGrid>
      </div>
    </section>
  );
}
